const en = {
    DOES_NOT_CONTAIN: 'Does not contain',
    CONTAINS: 'Contains',
    RANGE: 'Range of',
    EQUALS: 'Equals',
    ENDS_WITH: 'Ends with',
    STARTS_WITH: 'Starts with',
    APPLY: 'Apply',
    NUMERIC: 'Numeric',
    TO: 'to'
};
export { en };
